import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

export const leaveMessageOptions = [
  { value: 'true', label: <FormattedMessage {...messages.yes} /> },
  { value: 'false', label: <FormattedMessage {...messages.no} /> },
];
